import React from "react";
import styles from "./styles.css";
import rightArrow from "./images/arrow-right.svg";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { getPageSectionByName } from "../../../utils/helpers/get-cms-section";
import { CMS_SLUG_CONSTANTS } from "../../../constants/optimize-constants";
import { getSellerTypeStyle, PLATFORMS, STYLE_COMPONENTS, STYLE_KEYS } from "../../../constants/app-constants";

const Cars24QualityPromiseRevamp = ({isLuxuryCar, cmsConfig}) => {
    const history = useHistory();
    const handleCardClick = (data) => {
        if (data.isRelative) {
            history.push(data.link);
        } else {
            window.open(data.link, "_blank");
        }

    };

    const cmsContent = getPageSectionByName(cmsConfig?.data?.pageSections, CMS_SLUG_CONSTANTS.CAR24_PROMISE_DETAILS);
    const promiseDetails = cmsContent?.meta;

    const currentContent = isLuxuryCar ? promiseDetails?.LUXURY : promiseDetails?.PRIME;

    const rightPanelStyle = getSellerTypeStyle(PLATFORMS.DESKTOP, STYLE_COMPONENTS.QUALITY_PROMISE, STYLE_KEYS.RIGHT_PANEL, isLuxuryCar, false);
    const containerStyle = getSellerTypeStyle(PLATFORMS.DESKTOP, STYLE_COMPONENTS.QUALITY_PROMISE, STYLE_KEYS.CONTAINER, isLuxuryCar, false);

    return (
        <div styleName={containerStyle}>
            <div styleName={"styles.leftPanel"}>
                <p styleName={"styles.heading"}>{currentContent?.heading}</p>
                <p styleName={"styles.detail"}>{currentContent?.content}</p>
                <div styleName={"styles.buttonWrapper"}>
                    {currentContent?.values?.map((item) => (
                        <div styleName={"styles.button"} onClick={() => handleCardClick(item)}>
                            <p styleName={"styles.buttonText"} >{item.name}</p>
                            <img src={rightArrow} />
                        </div>
                    ))}
                </div>
            </div>
            <div styleName={rightPanelStyle}>
                <img src={currentContent?.icons} />
            </div>
        </div>
    );
};

Cars24QualityPromiseRevamp.propTypes = {
    isLuxuryCar: PropTypes.bool,
    cmsConfig: PropTypes.object
};

export default Cars24QualityPromiseRevamp;
